var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 15.5H13.875V12.75H12.5V15.5H9.75V16.875H12.5V19.625H13.875V16.875H16.625V15.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.25H1.5V1.74999H7V5.87499C7.00105 6.23934 7.14626 6.58847 7.40389 6.8461C7.66153 7.10374 8.01065 7.24894 8.375 7.24999H12.5V9.99999H13.875V5.87499C13.8775 5.78463 13.8603 5.69482 13.8247 5.61173C13.7891 5.52865 13.7359 5.45428 13.6688 5.39374L8.85625 0.581242C8.79573 0.514093 8.72136 0.460877 8.63827 0.425268C8.55519 0.38966 8.46536 0.372506 8.375 0.374992H1.5C1.13565 0.376044 0.786525 0.521248 0.52889 0.778883C0.271255 1.03652 0.126052 1.38564 0.125 1.74999V18.25C0.126052 18.6143 0.271255 18.9635 0.52889 19.2211C0.786525 19.4787 1.13565 19.6239 1.5 19.625H7V18.25ZM8.375 2.02499L12.225 5.87499H8.375V2.02499Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocAdd);
export default __webpack_public_path__ + "static/media/doc_add.348900c34681bbb739de25b5b410568f.svg";
export { ForwardRef as ReactComponent };